import type { SVGProps } from 'react'

const AutomatedDataIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <ellipse cx="30" cy="30" rx="30" ry="30" fill="currentColor" />
    <path
      d="M17.0874 19.0212V29.0011C17.0874 29.0011 17.0874 33.991 28.7305 33.991C40.3737 33.991 40.3737 29.0011 40.3737 29.0011V19.0212"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.7305 14.0315C40.3737 14.0315 40.3737 19.0214 40.3737 19.0214C40.3737 19.0214 40.3737 24.0113 28.7305 24.0113C17.0874 24.0113 17.0874 19.0214 17.0874 19.0214C17.0874 19.0214 17.0874 14.0315 28.7305 14.0315Z"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.7305 43.9707C17.0874 43.9707 17.0874 38.9808 17.0874 38.9808V29.001"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.9271 37.594V41.173H41.3481"
      stroke="#0066FF"
      strokeWidth="1.83192"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.4308 44.1571C43.0431 45.2546 42.3091 46.1963 41.3396 46.8404C40.3701 47.4845 39.2174 47.796 38.0554 47.728C36.8934 47.6601 35.785 47.2163 34.8972 46.4635C34.0094 45.7108 33.3902 44.6899 33.1331 43.5546C32.876 42.4194 32.9948 41.2313 33.4716 40.1695C33.9485 39.1077 34.7575 38.2296 35.7768 37.6675C36.7961 37.1055 37.9704 36.89 39.1229 37.0535C40.2753 37.2169 41.3435 37.7505 42.1663 38.5738L44.928 41.1746"
      stroke="#0066FF"
      strokeWidth="1.83192"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default AutomatedDataIcon
